import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function Landing() {
  const { lang, t } = useApp();
  const head = lang === "hi" ? "font-hi" : "font-display";

  return (
    <div data-testid="landing-page">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 hero-grain opacity-70" aria-hidden />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-10 lg:pt-20 pb-10 lg:pb-24 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7 reveal">
            <div className="text-xs tracking-[0.3em] uppercase font-semibold text-[#C9A84C] mb-6" data-testid="hero-eyebrow">
              ✦ {t.landing.eyebrow}
            </div>
            <h1 className={`${head} text-4xl sm:text-5xl lg:text-7xl text-[#2D1820] leading-[1.05] tracking-tight font-light`} data-testid="hero-title">
              {t.landing.titleA}
              <br />
              <span className="italic text-[#6B1F3A]">{t.landing.titleB}</span>
            </h1>
            <p className="mt-7 max-w-xl text-[15px] sm:text-base leading-relaxed text-[#635057]" data-testid="hero-subtitle">
              {t.landing.subtitle}
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <Link to="/store/demo-bazaar" className="btn-primary text-center" data-testid="hero-demo-btn">
                {t.landing.ctaPrimary}
              </Link>
              <Link to="/signup" className="btn-secondary text-center" data-testid="hero-signup-btn">
                {t.landing.ctaSecondary}
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5 reveal reveal-delay-1">
            <div className="relative">
              <div className="absolute -inset-3 border border-[#C9A84C]/40" aria-hidden />
              <img
                src="https://images.pexels.com/photos/36041239/pexels-photo-36041239.jpeg"
                alt="Saree elegance"
                className="relative w-full h-[420px] sm:h-[520px] object-cover"
                data-testid="hero-image"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur px-4 py-3 flex items-center justify-between">
                <div className="text-[10px] tracking-[0.25em] uppercase text-[#6B1F3A] font-semibold">Live try-on preview</div>
                <span className="w-2 h-2 rounded-full bg-[#C9A84C] animate-pulse" />
              </div>
            </div>
          </div>
        </div>

        {/* Marquee */}
        <div className="border-y border-[#E8DFDC] overflow-hidden bg-[#FCFAF8]">
          <div className="flex whitespace-nowrap marquee-track py-3">
            {[...Array(6)].map((_, i) => (
              <span key={i} className={`${head} text-[#6B1F3A] mx-8 text-lg italic`}>
                {t.landing.marquee}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 lg:py-32">
        <div className="text-xs tracking-[0.3em] uppercase font-semibold text-[#C9A84C] mb-3">
          ✦ {t.landing.featuresTitle}
        </div>
        <h2 className={`${head} text-3xl sm:text-4xl lg:text-5xl text-[#2D1820] font-light tracking-tight max-w-2xl`}>
          {t.landing.titleA} <span className="italic text-[#6B1F3A]">{t.landing.titleB}</span>
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {t.landing.features.map((f, idx) => (
            <div
              key={idx}
              className={`bg-white border border-[#E8DFDC] p-7 hover:shadow-[0_20px_40px_rgba(107,31,58,0.06)] transition-shadow reveal reveal-delay-${idx + 1}`}
              data-testid={`feature-card-${idx + 1}`}
            >
              <div className={`${head} text-5xl text-[#C9A84C] font-light leading-none`}>{f.k}</div>
              <div className="mt-6 text-[17px] font-medium text-[#2D1820]">{f.t}</div>
              <p className="mt-3 text-sm text-[#635057] leading-relaxed">{f.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
